import React, { memo } from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';

import { TreeSelector } from 'redpoints-front-components/index';

import { testPurchaseSetFiltersSelected } from '../../../actions/testPurchaseActions';
import {
  getTestPurchaseDomainsIsLoaded,
  getTestPurchaseDomainsTreeData,
  getTestPurchaseFiltersSelected,
  getTestPurchaseFiltersSelectedTreeData,
} from '../../../reducers/tasks/testPurchase';
import { translate } from '../../../helpers/languageHelper';
import { parseTreeValuesToSelected } from './testPurchaseFiltersHelpers';

const TestPurchaseFiltersDomains = ({
  filtersSelected: { filterBy },
  domainsSelectedTreeData,
  domainsTreeData,
  testPurchaseSetFiltersSelected,
  isLoadedDomainsPlatforms,
}) => {
  const handleDomainsPlatformsChange = values => {
    const parsedValues = parseTreeValuesToSelected(values);
    testPurchaseSetFiltersSelected({
      filterBy,
      ...parsedValues,
    });
  };

  return (
    isLoadedDomainsPlatforms && (
      <TreeSelector
        aria-label="domains platforms selector"
        label={translate('tasks.testPurchase.filter.domain.label')}
        placeholder={translate('tasks.testPurchase.filter.domain.placeHolder')}
        onChange={handleDomainsPlatformsChange}
        treeCheckable
        value={domainsSelectedTreeData}
        treeData={domainsTreeData}
        allowClear
        dropdownStyle={{ maxHeight: 300 }}
      />
    )
  );
};

const mapStateToProps = state => ({
  domainsSelectedTreeData: getTestPurchaseFiltersSelectedTreeData(state),
  domainsTreeData: getTestPurchaseDomainsTreeData(state),
  filtersSelected: getTestPurchaseFiltersSelected(state),
  isLoadedDomainsPlatforms: getTestPurchaseDomainsIsLoaded(state),
});

export default compose(
  connect(mapStateToProps, {
    testPurchaseSetFiltersSelected,
  }),
  memo
)(TestPurchaseFiltersDomains);
